import { render, staticRenderFns } from "./matchCard.vue?vue&type=template&id=65055b9c&scoped=true&"
import script from "./matchCard.vue?vue&type=script&lang=js&"
export * from "./matchCard.vue?vue&type=script&lang=js&"
import style0 from "./matchCard.vue?vue&type=style&index=0&id=65055b9c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65055b9c",
  null
  
)

export default component.exports